import { Button, Stack, Textarea } from "@chakra-ui/react";
import { AiOutlineSend } from "react-icons/ai";

function LiveStreamChatBox({message,setMessage,onEnter,onSend}) {
  return (
    <Stack
      bottom={["0px", "30px"]}
      direction="row"
      alignItems={"center"}
      borderRadius={"10px"}
      p="2px 5px"
      bg="#D9D9D94F"
    >
      <Textarea
        className="scroll-container"
        value={message}
        onChange={(e) => {
          setMessage(e.target.value);
        }}
        onKeyDown={onEnter}
        rows="1"
        size={"sm"}
        style={{ resize: "none" }}
        color="#000"
        fontWeight="600"
        fontSize={[".8em", "unset"]}
        _placeholder={{ color: "#7D96B3", fontWeight: "initial" }}
        placeholder="Type a message..."
        type="text"
        bg={"transparent"}
        overflow=""
        border="none"
      />
      <Stack direction={"row"} alignItems="center" ml="-80px" mt="20px">
        <Button
        disabled={message.trim().length === 0} onClick={onSend}
          bg="#50BB69"
          color="#fff"
          borderRadius={"10px"}
          w="40px"
          h="40px"
          p="0"
        >
          <AiOutlineSend cursor="pointer" />
        </Button>
      </Stack>
    </Stack>
  );
}

export default LiveStreamChatBox;
